import { buildSrcUrl } from '../util';

/**
 * 입력한 src 경로의 JSON 파일을 제너릭 Type으로 변환해 반환합니다.
 * @param src Load할 JSON 파일의 경로
 * @returns 입력한 제너릭 Type
 */
export const loadJson = async <T>(src: string) => {
  const metadata = (await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', buildSrcUrl(src));
    xhr.onload = (evt) => {
      resolve(JSON.parse(xhr.responseText));
    };
    xhr.onerror = (evt) => {
      reject(evt);
    };
    xhr.send();
  })) as T;

  return metadata;
};

export const downloadJSON = (filename: string, data: object) => {
  const json = JSON.stringify(data);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
